export const keywordToLink = (inputString, keywordList = []) => {
  const keywords = keywordList
    .reduce((acc, item) => {
      return acc.concat(item.keywords);
    }, [])
    .join("|");

  const regex = new RegExp(`\\b(?:${keywords})\\b`, "gi");

  return inputString.replace(regex, (match) => {
    const matchedItem = keywordList.find((item) =>
      item.keywords.includes(match.toLowerCase())
    );
    if (matchedItem) {
      return `<a href="${matchedItem.reference}" target="_blank" class="keyword-link">${match}</a>`;
    }
    return match;
  });
};

export const LIST_KEYWORDS = {
  soatVirtual: [{
    keywords: ["compra tu soat virtual", "consultas sobre tu soat virtual"],
    reference: "https://www.rimac.com/comprar/soat-digital"
  }],
}
